import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  MapPinIcon,
  ClockIcon,
  StarIcon,
  ShareIcon,
  CalendarIcon,
  UsersIcon,
  ArrowLeftIcon,
  HeartIcon,
} from "lucide-react";
import {
  useGetActivityDetailsQuery,
  useGetAllActivitiesQuery,
} from "../../../redux/service/customerServices";
import moment from "moment/moment";
import JoinActivityDialog from "./JoinActivityDialog/JoinActivityDialog";
// import { useAuth } from '../contexts/AuthContext'
// import { useChat } from '../contexts/ChatContext'
export const ActivitiesDetailView = () => {
  const { activityId } = useParams();
  //   const { isLoggedIn, userType } = useAuth()
  //   const { createChat, getChat } = useChat()
  const [showRequestModal, setShowRequestModal] = useState(false);
 const handleParticipationRequest = (message) => {
    
      alert('Request sent successfully! The organizer will review your request.')
    }
  //   const chat = getChat([currentUserId, organizerId])
  // Mock data - replace with real data fetch
  const userId = localStorage.getItem("user_id");

  const { data, isLoading, isFetching } =
    useGetActivityDetailsQuery(activityId);

  const {
    data: activitiesData,
    isFetching: activitiesDataIsFetching,
    isLoading: activitiesDataIsLoading,
  } = useGetAllActivitiesQuery();
  const [activityDetailsData, setActivityDetailsData] = useState({});
  const [activityData, setActivityData] = useState([]);

  useEffect(() => {
    if (!isLoading && !isFetching && data) {
      setActivityDetailsData(data);
    }
  }, [data, isLoading, isFetching]);

  useEffect(() => {
    if (!activitiesDataIsFetching && !activitiesDataIsLoading && activitiesData) {
      const similarActivitiesData = activitiesData?.slice(-2);
      setActivityData(similarActivitiesData);
    }
  }, [activitiesData, activitiesDataIsFetching, activitiesDataIsLoading]);

  const activity = {
    id: 1,
    title: "Morning Cycling",
    image:
      "https://images.unsplash.com/photo-1541625602330-2277a4c46182?ixlib=rb-4.0.3",
    description:
      "Join us for an invigorating morning cycling session through the scenic routes of Borivali. Perfect for both beginners and experienced cyclists. We'll explore beautiful trails while maintaining a comfortable pace for everyone. The route includes stops at scenic viewpoints for photos and a short break at a local café for refreshments.",
    location: "Borivali Park, Mumbai",
    date: "Jul 15, 2023",
    time: "06:00 AM - 08:00 AM",
    participants: 8,
    maxParticipants: 12,
    rating: 4.5,
    reviews: 24,
    price: "₹200",
    requirements: [
      "Own bicycle (or you can rent one nearby for ₹200)",
      "Helmet (mandatory)",
      "Water bottle",
      "Comfortable athletic wear",
      "Basic cycling experience",
    ],
    safetyNotices: [
      "This activity requires physical exertion. Please ensure you are in good health before participating.",
      "Helmets are mandatory for all participants",
      "Follow traffic rules and stay with the group",
      "Bring necessary safety gear",
    ],
    organizer: {
      name: "Kunal Sharma",
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3",
      rating: 4.5,
      totalActivities: 15,
      memberSince: "June 2023",
      bio: "Cycling enthusiast and nature lover. I organize weekly cycling trips around Mumbai to discover hidden gems of the city.",
    },
    similarActivities: [
      {
        id: 2,
        title: "Evening Cycling",
        image:
          "https://images.unsplash.com/photo-1541625810516-44f1ce894bcd?ixlib=rb-4.0.3",
        date: "Jul 20, 06:00 PM",
        participants: 5,
        maxParticipants: 10,
      },
      {
        id: 3,
        title: "Mountain Biking",
        image:
          "https://images.unsplash.com/photo-1544191696-102ad421c85f?ixlib=rb-4.0.3",
        date: "Jul 22, 07:00 AM",
        participants: 3,
        maxParticipants: 8,
      },
    ],
  };
  const renderStars = (rating) => (
    <div className="flex">
      {[...Array(5)].map((_, i) => (
        <StarIcon
          key={i}
          className={`h-4 w-4 ${
            i < Math.floor(rating)
              ? "text-yellow-400 fill-yellow-400"
              : "text-gray-300"
          }`}
        />
      ))}
    </div>
  );
  const handleJoinClick = () => {
    // if (!isLoggedIn) {
    //   alert('Please log in to join activities')
    //   return
    // }
    setShowRequestModal(true);
  };
  return (
   isLoading || isFetching ?  <div className="min-h-screen bg-gray-50 pt-16 animate-pulse">
  {/* Navigation Skeleton */}
  <div className="bg-white border-b border-gray-200">
    <div className="container mx-auto px-4 py-4">
      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-3">
          <div className="h-5 w-5 bg-gray-300 rounded-full" />
          <div className="h-4 w-24 bg-gray-300 rounded" />
        </div>
        <div className="flex gap-2">
          <div className="h-5 w-5 bg-gray-300 rounded" />
          <div className="h-5 w-5 bg-gray-300 rounded" />
        </div>
      </div>
    </div>
  </div>

  <div className="container mx-auto px-4 py-8">
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
      {/* Left/Main Content Skeleton */}
      <div className="lg:col-span-2">
        <div className="bg-white rounded-lg overflow-hidden shadow-sm">
          <div className="w-full h-[400px] bg-gray-200" />
          <div className="p-6 space-y-6">
            <div className="h-8 bg-gray-300 w-3/4 rounded" />
            <div className="flex flex-wrap gap-6">
              <div className="h-4 w-32 bg-gray-300 rounded" />
              <div className="h-4 w-24 bg-gray-300 rounded" />
              <div className="h-4 w-40 bg-gray-300 rounded" />
            </div>
            <div className="h-4 w-44 bg-gray-300 rounded mb-4" />
            <div className="space-y-3">
              <div className="h-5 w-32 bg-gray-300 rounded" />
              <div className="h-4 w-full bg-gray-200 rounded" />
              <div className="h-4 w-5/6 bg-gray-200 rounded" />
              <div className="h-4 w-3/4 bg-gray-200 rounded" />
            </div>
          </div>
        </div>
      </div>

      {/* Right Sidebar Skeleton */}
      <div className="lg:col-span-1 space-y-6">
        {/* Action Card */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="h-12 bg-gray-300 rounded w-full" />
        </div>

        {/* Organizer Card */}
        <div className="bg-purple-50 rounded-lg shadow-sm p-6 space-y-4">
          <div className="h-6 w-40 bg-gray-300 rounded" />
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-gray-300 rounded-full" />
            <div className="space-y-2">
              <div className="h-4 w-24 bg-gray-300 rounded" />
              <div className="h-3 w-20 bg-gray-200 rounded" />
            </div>
          </div>
        </div>

        {/* Similar Activities Skeleton */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="h-6 w-48 bg-gray-300 rounded mb-4" />
          <div className="space-y-4">
            {Array(2).fill(0).map((_, i) => (
              <div key={i} className="flex items-center gap-4 p-2">
                <div className="w-20 h-20 bg-gray-300 rounded-lg" />
                <div className="space-y-2">
                  <div className="h-4 w-32 bg-gray-300 rounded" />
                  <div className="h-3 w-28 bg-gray-200 rounded" />
                  <div className="h-3 w-20 bg-gray-200 rounded" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  :  <div className="min-h-screen bg-gray-50 pt-16">
      {/* Navigation */}
      <div className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            <Link
              to="/activities"
              className="flex items-center text-gray-600 hover:text-gray-900"
            >
              <ArrowLeftIcon className="h-5 w-5 mr-2" />
              Activities
            </Link>
            <div className="flex gap-2">
              <button className="p-2 text-gray-600 hover:text-gray-900">
                <ShareIcon className="h-5 w-5" />
              </button>
              <button className="p-2 text-gray-600 hover:text-gray-900">
                <HeartIcon className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Main Content */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-lg overflow-hidden shadow-sm">
              <img
                src={activityDetailsData?.uploaded_images?.[0]}
                alt={activityDetailsData.activity_title}
                className="w-full h-[400px] object-cover"
              />
              <div className="p-6">
                <h1 className="text-3xl font-bold text-gray-900 mb-4">
                  {activityDetailsData.activity_title}
                </h1>
                <div className="flex flex-wrap gap-4 mb-6">
                  <div className="flex items-center text-gray-600">
                    <CalendarIcon className="h-5 w-5 mr-2" />
                    {new Date(
                      activityDetailsData.start_date
                    ).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })}
                  </div>
                  <div className="flex items-center text-gray-600">
                    <ClockIcon className="h-5 w-5 mr-2" />

                    {moment(
                      activityDetailsData.start_time,
                      "HH:mm:ss.SSSSSS"
                    ).format("hh:mm A")}
                  </div>
                  <div className="flex items-center text-gray-600">
                    <MapPinIcon className="h-8 w-8 mr-2" />
                    {`${activityDetailsData.location},${activityDetailsData.location}`}
                  </div>
                </div>
                <div className="flex items-center gap-4 mb-6 pb-6 border-b border-gray-100">
                  {/* <div className="flex items-center">
                    {renderStars(activity.rating)}
                    <span className="ml-2 text-gray-600">
                      ({activity.reviews} reviews)
                    </span>
                  </div> */}
                  <div className="flex items-center text-gray-600">
                    <UsersIcon className="h-5 w-5 mr-2" />
                    <span className="mx-1">
                      {" "}
                      {activityDetailsData?.maximum_participants}
                    </span>
                    participants
                  </div>
                </div>
                <div className="mb-8">
                  <h2 className="text-xl font-semibold text-gray-900 mb-3">
                    About Activity
                  </h2>
                  <p className="text-gray-600 leading-relaxed">
                    {activityDetailsData.activity_description}
                  </p>
                </div>
                {/* <div className="mb-8">
                  <h2 className="text-xl font-semibold text-gray-900 mb-4">
                    What to Bring
                  </h2>
                  <ul className="space-y-3">
                    {activity.requirements.map((req, index) => (
                      <li key={index} className="flex items-start">
                        <CheckCircle2Icon className="h-5 w-5 text-green-500 mr-3 mt-0.5" />
                        <span className="text-gray-600">{req}</span>
                      </li>
                    ))}
                  </ul>
                </div> */}
                {/* <div className="bg-blue-50 rounded-lg p-4 mb-8">
                  <h2 className="text-lg font-semibold text-blue-900 mb-3 flex items-center">
                    <AlertCircleIcon className="h-5 w-5 mr-2" />
                    Safety Notice
                  </h2>
                  <ul className="space-y-2">
                    {activity.safetyNotices.map((notice, index) => (
                      <li
                        key={index}
                        className="text-blue-800 text-sm flex items-start"
                      >
                        <span className="mr-2">•</span>
                        {notice}
                      </li>
                    ))}
                  </ul>
                </div> */}
              </div>
            </div>
          </div>
          {/* Sidebar */}
          <div className="lg:col-span-1 space-y-6">
            {/* Action Card */}
            <div className="bg-white rounded-lg shadow-sm p-6">
               <span className="text-xs text-orange-500 font-semibold">
                        Coming Soon
                      </span>
              <button
              // disabled={userId === activityDetailsData?.user_id}
              disabled={true}
                onClick={handleJoinClick}
                className={`w-full ${userId === activityDetailsData?.user_id ? 'bg-orange-200' :'bg-orange-500 hover:bg-orange-600'}  text-white px-6 py-3 rounded-md font-medium  transition-colors mb-3`}
              >
                Join Activity
              </button>
            </div>
            {/* Organizer Card */}
            <div className="bg-purple-50 rounded-lg shadow-sm p-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                Activity Organizer
              </h2>
              <div className="flex items-center mb-4">
                <img
                  src={activityDetailsData.organizer_profile_picture}
                  alt={activityDetailsData.created_by}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <h3 className="font-medium text-gray-900">
                    {activityDetailsData.created_by}
                  </h3>
                  {/* <div className="flex items-center text-sm text-gray-600">
                    {renderStars(activity.organizer.rating)}
                    <span className="ml-2">
                      {activity.organizer.rating} rating
                    </span>
                  </div> */}
                </div>
              </div>
              {/* <p className="text-gray-600 text-sm mb-4">
                {activity.organizer.bio}
              </p> */}
              {/* <div className="space-y-2 text-sm text-gray-600 mb-4">
                <div className="flex items-center">
                  <CalendarIcon className="h-4 w-4 mr-2" />
                  {activity.organizer.totalActivities} activities hosted
                </div>
                <div className="flex items-center">
                  <UserIcon className="h-4 w-4 mr-2" />
                  Member since {activity.organizer.memberSince}
                </div>
              </div>
              <button className="w-full border border-gray-300 bg-white text-gray-700 px-4 py-2 rounded-md font-medium hover:bg-gray-50 transition-colors">
                Contact Organizer
              </button> */}
            </div>
            {/* Similar Activities */}
            <div className="bg-white rounded-lg shadow-sm p-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                Similar Activities
              </h2>
              <div className="space-y-4">
                {activityData?.map((similar) => (
                  <Link
                    key={similar.activity_id}
                    to={`/ActivitiesDetails/${similar.activity_id}`}
                    className="flex items-center gap-4 p-2 hover:bg-gray-50 rounded-lg"
                  >
                    <img
                      src={similar?.uploaded_images?.[0]}
                      alt={similar.activity_title}
                      className="w-20 h-20 object-cover rounded-lg"
                    />
                    <div>
                      <h3 className="font-medium text-gray-900">
                        {similar.activity_title}
                      </h3>
                      <p className="text-sm text-gray-600 flex gap-2">
                        {new Date(similar.start_date).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "long",
                            year: "numeric",
                          }
                        )}
                        ,
                        {moment(similar.start_time, "HH:mm:ss.SSSSSS").format(
                          "hh:mm A"
                        )}
                      </p>
                      <div className=" flex gap-1 text-sm text-gray-600">
                        <span>{similar.maximum_participants || 0}</span>
                        participants
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modals */}
      {showRequestModal && (
        <JoinActivityDialog
          activityName={activity.title}
          onSubmit={handleParticipationRequest}
          onClose={() => setShowRequestModal(false)}
          activityId={activityId}
        />
      )}
    </div>
  );
};
